import * as React from 'react';
import { AgencyModal, MultipleBuildersModal } from '@cian/frontend-newbuilding-sellers-info-components';

import { SellersBanner } from '../../components/NewbuildingCallToAction/SellersBanner';

export interface ISellersBannerContainerProps {
  type: 'builder' | 'seller';
  isMultipleSellers: boolean;
}

export const SellersBannerContainer: React.FC<ISellersBannerContainerProps> = ({ type, isMultipleSellers }) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = React.useCallback(() => setOpen(true), []);
  const handleClose = React.useCallback(() => setOpen(false), []);

  return (
    <>
      <SellersBanner isMultipleSellers={isMultipleSellers} onClick={handleOpen} type={type} />
      {type === 'builder' ? (
        <MultipleBuildersModal onClose={handleClose} open={open} />
      ) : (
        <AgencyModal onClose={handleClose} open={open} />
      )}
    </>
  );
};
